import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import i18n from './lang';
import axios from 'axios';
import Toaster from 'v-toaster';
import 'v-toaster/dist/v-toaster.css';
import VuePagination from 'vue-bs-pagination';
// import * as Sentry from '@sentry/browser';
import Multiselect from 'vue-multiselect';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import VTooltip from 'v-tooltip';
import FBSignInButton from 'vue-facebook-signin-button';
import linkify from 'vue-linkify';
import ProgressBar from 'vuejs-progress-bar';
import {ServerTable, ClientTable, Event} from 'vue-tables-2';

Raven
    .config('https://7046ddd12c0a4d03b4d30ecf059d8e06@sentry.digitalish.co.jp/7', {
      environemnt: process.env.NODE_ENV,
      shouldSendCallback: function() {
        return ['production', 'staging'].indexOf(process.env.NODE_ENV) !== -1
      }
    })
    .addPlugin(RavenVue, Vue)
    .install();

Vue.use(ServerTable, {}, false, 'bootstrap3','default');
Vue.use(ProgressBar)

Vue.directive('linkified', linkify)


Vue.use(VTooltip)

Vue.component('multiselect', Multiselect)


Vue.use(FBSignInButton)

Vue.component('VuePagination', VuePagination);

Vue.use(Toaster, {
    timeout: 5000
})

window.fbAsyncInit = function() {
    FB.init({
      appId: process.env.VUE_APP_FB_APP_ID,
      cookie: true,
      xfbml: true,
      version: 'v3.2'
    });
  };

export const EventBus = new Vue();

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  axios,
  render: h => h(App)
}).$mount(document.getElementById('app'))
